export const languageStringsCampaign = {
  leavingWithChanges: "Nie zapisałeś zmian w kampanii. Chcesz je cofnąć?",
  addFirstCampaign: "Dodaj swoją pierwszą kampanię",
  setUpFirstCampaign: "Skonfiguruj swoją pierwszą kampanię i zacznij zarabiać.",
  addCampaign: "Dodaj kampanię",
  addNotification: "Dodaj notyfikację",
  deleteCampaign: "Czy usunąć kampanię?",
  preview: "Podgląd",
  unnamedCampaign: "(bez nazwy)",
  table: {
    name: "Imię",
    creationDate: "Utworzona",
    notificationCount: "Notyfikacja",
    status: "Status",
    delete: "Usuń",
  },
  settings: {
    all: "WYŚWIETLAJ WSZĘDZIE",
    custom: "WŁASNY WYBÓR",
    title: "Wizualizacja",
    campaignName: "Nazwa kampanii",
    setCampaign: "Ustawienia kampanii",
    newCampaign: "Nowa kampania",
    whereWillCampaignBeShown: "Kiedy kampania będzie wyświetlana",
    allDescription:
      'Powiadomienia będą wyświetlane na całej Twojej stronie internetowej. Jeśli chcesz wykluczyć niektóre strony z wyświetlania powiadomień lub określić tylko konkretne strony, na których będą wyświetlane powiadomienia tej kampanii, przełącz wybór na „Własny wybór".',
    url: {
      title: "odnośnik do strony internetowej (URL)",
      startsWith: "Zaczyna się od",
      includes: "Zawiera",
      equals: "Jest zgodny z",
    },
    includes: "Obejmuje",
    exclude: "Wyklucza (niewymagane)",
    addCondition: "Dodaj warunek",
  },
  design: {
    title: "Urządzenia",
    notificationsDesign: "Wygląd notyfikacji",
    designDescription:
      "Ustawienia dotyczą całej kampanii, wygląd konkretnej notyfikacji można zmienić w ustawieniach tej notyfikacji.",
    computerOff:
      "Powiadomienia nie będą wyświetlane na urządzeniach stacjonarnych (PC)",
    mobileOff: "Powiadomienia nie będą wyświetlane na urządzeniach mobilnych",
    computer: "Wyświetl dla komputera",
    mobile: "Wyświetl dla telefonu",
    position: "Pozycja",
    downLeftCorner: "Dolny lewy róg",
    downRightCorner: "Dolny prawy róg",
    upLeftCorner: "Górny lewy róg",
    upRightCorner: "Górny prawy róg",
    down: "U dołu",
    up: "U góry",
    animations: "Animacja",
    playAnimation: "Uruchom animację",
    animationSettings: {
      showAfter: "Notyfikacja pojawi się po",
      showDelay: "Czas wyświetlenia",
      delayBetween: "Przerwa między notyfikacjami",
      showSpeed: "Prędkość wyświetlenia",
      second: "sekund",
      seconds: "sekundach",
    },
  },
  notifications: {
    title: "Notyfikacja",
    noNotifications: "Na razie nie masz żadnych notyfikacji",
    addNewNotification: "Dodaj notyfikację",
    addNotificationHelperText:
      "Wybierz i kliknij co najmniej jedno z 8 wyświetlonych pól (typów powiadomień).",
    table: {
      type: "Rodzaj",
      preview: "Podgląd",
      status: "Wyłączone / Włączone",
    },
    settings: {
      customization: {
        title: "Ustawienia",
      },
      displayRules: {
        title: "Zasady wyświetlania",
        text: "Tekst",
        notificationText: "Tekst notyfikacji",
        variant: "Wariant",
        choseVariant: "Wybierz wariant",
        days: "dni",
        h: "h",
        addKey: "Wprowadź klucz API",
        show: "Wyświetla",
        notificationName: "Nazwa notyfikacji",
        nameNotification: "Nadaj nazwę notyfikacji",
        repeatNotification: "Powtarzanie notyfikacji",
        fillNotificationText: "Wprowadź tekst notyfikacji",
        actualVisitors: {
          nameVisitors: "Nadaj nazwę użytkownikom",
          visitors: "użytkowników",
          maxVisitors: "Minimalna liczba użytkowników do wyświetlenia",
        },
        lastOrders: {
          maxLast: "Maksymalnie ostatnie",
          maxToShow: "Minimalna liczba do wyświetlenia wynosi",
          whenAtLeast: "Notyfikacja tylko wtedy, gdy jest przynajmniej",
          ordersLast: "Zamówienia w ciągu ostatnich",
          haveOrderedPlaceholder: "już zamówił/a. Co z tobą?",
          showOwnOrders: "Pokaż użytkownikom własne zamówienia",
          notRecoginzed: 'Nierozpoznane imiona jako "Gość"',
          orders: "zamówień",
        },
        lastRegistrations: {
          maxLast: "Maksymalnie ostatnie",
          registrations: "rejestracji",
          notRecoginzed: 'Nierozpoznane imiona jako "Użytkownik odwiedzający"',
          registrationsLast: "Rejestracja w ciągu ostatnich",
          showOwnRegistrations: "Pokaż użytkownikom własne rejestracje",
          isRegistredPlaceholder: "zakończył/a rejestrację",
        },
        visitorSummary: {
          visitors: "Użytkownicy odwiedzający",
          registrations: "Rejestracja",
          orders: "Zamówienia",
          visitors2: "użytkowników",
          registrations2: "rejestracji",
          orders2: "zamówień",
          last: "w ciągu ostatnich",
          minNumber: "Minimalna liczba",
          toShow: "do wyświetlenia",
        },
        individual: {
          link: "Link",
          button: "Przycisk",
          buttonName: "Nadaj nazwę",
          url: "Docelowy link do strony internetowej (URL)",
          buttonAsLink: "Link jako przycisk",
          textColor: "Kolor tekstu",
          openLinkInNewWindow: "Otwór link w nowym oknie",
          buttonColor: "Kolor przycisku",
          removedLinkDescription:
            "Po usunięciu linku można wprowadzić dłuższy tekst notyfikacji.",
          tooLongTextErrorMessage: "Tekst przekracza maksymalną długość.",
          tooltip:
            "Wprowadź pełny adres URL linku, w tym http://, https://. Jeśli wprowadzisz do tego pola na przykład link https://www.seznam.cz, odwiedzający stronę zostanie przekierowany na stronę https://www.seznam.cz po kliknięciu przycisku.",
        },
        webName: "Nazwa witryny",
        apiKey: "Klucz API",
        heureka: {
          title: "Połączenie z Heureką",
          description:
            "Do aktywacji tej notyfikacji wymagany jest klucz API Heureka. Czy dodać klucz API?",
          heurekaApiKey: "Klucz API Heureka",
          country: "Kraj",
          stars: "gwiazdkami",
          reviewsWithRating: "Opinie z ponad",
          maxReviews: "Minimalna liczba opinii do wyświetlenia",
          howToAddApiKey: {
            title: "Jak dodać klucz Heureka",
            first:
              "W koncie Heureka w menu górnym wybierz opcję Administrace e-shopu (Administracja sklepu internetowego).",
            second:
              "W lewym górnym menu wybierz opcję Sprawdzone przez klientów (Sprawdzone przez klientów).",
            third: "Skopiuj tajny klucz i wklej go w pole klucz API.",
            thirdHelp:
              'Klucz jest dostępny, jeżeli masz odpowiednią ilość ocen i spełniasz warunki programu „Ověřeno zákazníky".',
            fourth: "Sprawdź status",
          },
        },
        zbozi: {
          title: "Połączyć się z Zboží.cz",
          description:
            "Do aktywacji tej notyfikacji wymagany jest klucz API Zboží.cz. Czy dodać klucz API?",
          howToAddKey: "Jak dodać klucz API Zboží.cz",
          shopId: "ID punktu",
          storeReview: "oceny sklepu",
          productReview: "oceny produkty",
          maxReviews: "Minimalna liczba opinii do wyświetlenia",
          howToAddApiKey: {
            title: "Jak dodać klucz API Sklik",
            first:
              "Zaloguj się na swoje konto na sklik.cz i w górnym menu wybierz Ustawienia.",
            second:
              "W lewym menu znajdź opcję Klucze API i kliknij Dodaj klucz.",
            third:
              "Podaj nazwę klucza, skopiuj wygenerowany token odświeżania i wklej go w pole Klucz API powyżej. W pole ID punktu wpisz swoje ID prowizorni (ID provozovny) z Zboží.cz.",
            thirdHelp:
              "API Zboží.cz zostało zastąpione nowym API Sklik. ID punktu (ID provozovny) pozostaje takie samo – znajdziesz je na swoim koncie Zboží.cz w sekcji Provozovna.",
            fourth: "Sprawdź status połączenia za pomocą przycisku Sprawdź.",
          },
        },
        spolehlivaRecenze: {
          title: "Złączony Zaufane",
          description:
            "Aby aktywować to powiadomienie, musisz zalogować się do Zaufane. Czy chcesz się zalogować?",
          howToAddApiKey: {
            title: "Jak zalogować się do Zaufane",
            first: "Skopiuj shopid i hasło ze swojego konta Zaufane.",
            second: "Wprowadź te informacje w odpowiednich polach powyżej.",
            third: "Sprawdź status",
          },
        },
        googleReviews: {
          title: "Połączenie z recenzjami Google",
          apiKey: "Klucz API",
          searchPlace: "Wyszukaj swoją firmę w Mapach Google",
          placeId: "Identyfikator miejsca",
          companyName: "Nazwa firmy",
          description:
            "Aby aktywować to powiadomienie, musisz wypełnić Identyfikator miejsca (Place ID), który możesz znaleźć za pomocą pola wyszukiwania firm w Mapach Google.",
          howToAddApiKey: {
            title: "Jak dodać recenzje Google",
            first:
              "W polu Wyszukaj swoją firmę, zalecamy wprowadzenie identycznej nazwy, jaką masz w Mapach Google.",
            second:
              "W oknie wyszukiwania wybierz swoją firmę, która będzie źródłem recenzji. Pole Identyfikator miejsca zostanie automatycznie wypełnione",
            third: "Zweryfikuj status.",
          },
          maxReviews: "Minimalna liczba recenzji do wyświetlenia",
          reviewsWithRating: "Recenzje z więcej niż",
          stars: "gwiazdki",
          noOptions: "Brak opcji",
        },
        trustPilot: {
          title: "Połączenie z TrustPilot",
          description:
            "Aby aktywować to powiadomienie, wymagany jest klucz API TrustPilot i identyfikator jednostki biznesowej. Czy chcesz dodać klucz API?",
          howToAddApiKey: {
            title: "Jak dodać identyfikator TrustPilot",
            first: "Odwiedź swoją stronę biznesową TrustPilot",
            second:
              "Skopiuj nazwę z adresu URL. Z adresu https://trustpilot.com/review/moja-firma skopiuj tylko część moja-firma",
            third: "Wprowadź tę nazwę w powyższym polu",
          },
          minReviews: "Minimalna liczba recenzji do wyświetlenia",
          reviewsWithRating: "Recenzje z więcej niż",
          stars: "gwiazdkami",
        },
      },
      pairing: {
        title: "Połączenie",
        collectData: "Pobór danych",
        addCondition: "Dodaj warunek",
        cantEdit: "Nie można poddawać edycji",
        pairingCondition: "Zasada parowania",
        selectedDomain: "Wybrana domena",
        pageVisitors: "Użytkownicy odwiedzający poszczególne strony",
        domainVisitors: "Podsumowania użytkowników odwiedzających całą domenę",
        campaignCollects:
          "Kampania będzie przechwytywać użytkowników odwiedzających każdą stronę oddzielnie.",
      },
      design: {
        title: "Wygląd",
        description:
          "Wygląd domyślny jest ustawiony dla całej kampanii, w tym miejscu można go dostosować do konkretnej notyfikacji",
        backgroundColor: "Kolor tła",
        textColor: "Kolor tekstu",
        iconbackgroundColor: "Kolor tła ikony",
        iconColor: "Kolor ikony",
        roundedCorners: "Zaokrąglenie krawędzi",
        icon: "Ikona",
      },
    },
    deleteModal: {
      title: "Czy usunąć notyfikacje?",
      description: "Wszystkie dane zostaną usunięte.",
    },
    lastOrders: {
      title: "Ostatnie zamówienia",
      description:
        "Zalecane dla sklepów internetowych obsługujących 10 lub więcej zamówień tygodniowo.",
      previewText1: "Józef z Koszyc",
      previewText2: "złożył/a zamówienie",
    },
    lastRegistrations: {
      title: "Ostatnia rejestracja",
      description:
        "Zalecane dla platform popytowych i witryn pozyskujących kontakty.",
      previewText1: "Józef z Koszyc",
      previewText2: "zakończył/a rejestrację",
    },
    actualVisitors: {
      title: "Odwiedzalność - aktualne statystyki",
      description:
        "Zalecane dla witryn, których minimalna dzienna odwiedzalność wynosi 1 000.",
      previewText1: "użytkowników",
    },
    visitorSummary: {
      title: "Odwiedzalność - statystyki sumaryczne",
      description:
        "Zalecane dla witryn, których dzienna odwiedzalność jest niższa niż 1 000.",
      previewText1: "użytkowników",
      previewText2: "użytkownicy",
    },
    registrationSummary: {
      title: "Rejestracje - statystyki sumaryczne",
    },
    orderSummary: {
      title: "Odwiedzalność - statystyki sumaryczne",
    },
    heureka: {
      title: "Heuréka - opinie i oceny",
      description:
        "Zalecane dla sklepów internetowych, które posiadają pozytywne opinie tekstowe na portalu Heuréka",
      previewText1:
        "W porównaniu do 12 pro max doceniam wspaniałą kamerę (filmy 4k są top), a także zdjęcia - ogromna różnica i zmiana na lepsze. Znakomite makro. Szybki i niezawodny telefon. Ogromna satysfakcja. Kolor jest piękny.",
      previewText2: "poleca",
    },
    zbozi: {
      title: "Zboží - opinie i oceny",
      description:
        "Zalecane dla sklepów internetowych, które posiadają pozytywne opinie tekstowe na portalu Zboží.cz",
      previewText1:
        "W porównaniu do 12 pro max doceniam wspaniałą kamerę (filmy 4k są top), a także zdjęcia - ogromna różnica i zmiana na lepsze. Znakomite makro. Szybki i niezawodny telefon. Ogromna satysfakcja. Kolor jest piękny.",
      previewText2: "poleca",
    },
    individual: {
      title: "Własny",
      description:
        "Wpisz własny tekst notyfikacji. Świetna notyfikacja do zakomunikowania zniżki, darmowej dostawy i innych benefitów dotyczących produktów i usług.",
      previewText1:
        "Zarejestruj się w naszym sklepie internetowym i skorzystaj z rabatu 5% na zakupy.",
      previewText2: "Otrzymaj prezent",
    },
    shoptetLastOrders: {
      title: "Ostatnie zamówienia dla Shoptet",
      description:
        "Ekskluzywne powiadomienia dla e-sklepów na platformie Shoptet.",
      timeRange: "Zakres czasu",
      showRandom: "Pokaż losowe zamówienia jako ostatnie ",
      twoMonths: "2 miesiące",
      screwdriver: "Śrubokręt",
    },
    eshopRychleLastOrders: {
      title: "Ostatnie zamówienia dla Eshop-rychle",
      description:
        "Ekskluzywne powiadomienia dla e-sklepów na platformie Eshop-rychle.",
      timeRange: "Zakres czasu",
      showRandom: "Pokaż losowe zamówienia jako ostatnie ",
      twoMonths: "2 miesiące",
      screwdriver: "Śrubokręt",
    },
    shoptetCouponCode: {
      title: "Shoptet kod rabatowy",
      description:
        "Ekskluzywne powiadomienia dla e-sklepów na platformie Shoptet.",
      info: "Notyfikacja zakłada istnienie kuponu rabatowego na platformie Shoptet, tutaj należy podać informacje na jego temat",
      code: "Kod rabatowy",
      saleType: "Wartość rabatu",
      saleIn: "Zniżka w",
      saleOn: "Zniżka dla",
      wholeSale: "Cały zakup",
      sale10: "RABAT10",
      previewText:
        'Użyj kodu rabatowego „RABAT10" i uzyskaj 10% rabatu na całe zakupy.',
    },
    shopifyLastOrders: {
      title: "Ostatnie zamówienia dla Shopify",
      description: "Ekskluzywne powiadomienia dla e-sklepów na platformie Shopify.",
      timeRange: "Zakres czasowy",
      showRandom: "Wyświetlaj losowe zamówienia z ostatnich",
      twoMonths: "2 miesiące",
      screwdriver: "iPhone 15 Pro",
    },
    spolehlivaRecenzeShopRating: {
      title: "Zaufane - recenzje i oceny",
      description:
        "Polecane dla e-sklepów, które mają pozytywne recenzje tekstowe zaufane.pl",
      previewText1:
        "Zakupy w tym sklepie internetowym były wspaniałe. Zamówienie dotarło szybko, a towar przekroczył moje oczekiwania. Doskonała obsługa klienta, na pewno zrobię zakupy ponownie!",
    },
    spolehlivaRecenzeProductRating: {
      title: "Zaufane - recenzje i oceny",
      description:
        "Polecane dla e-sklepów, które mają pozytywne recenzje tekstowe zaufane.pl",
      previewText1:
        "Ten produkt jest absolutnie fantastyczny! Jakość wykonania jest na wysokim poziomie, działa dokładnie zgodnie z opisem, a stosunek ceny do jakości jest doskonały. Mogę tylko polecić.",
    },
    googleReviews: {
      title: "Recenzje Google - opinie i oceny",
      description:
        "Polecane dla sklepów internetowych, które mają pozytywne recenzje tekstowe na Google",
      previewText1:
        "W porównaniu z 12 pro max doceniam niesamowitą kamerę (filmy 4k są najlepsze) a także zdjęcia - ogromna różnica i postęp. Świetne makro. Szybki i niezawodny telefon. Duże zadowolenie. Kolor jest piękny.",
      previewText2: "poleca",
    },
    trustPilot: {
      title: "TrustPilot - recenzje i oceny",
      description:
        "Polecane dla sklepów internetowych, które mają pozytywne recenzje tekstowe na TrustPilot",
      previewText1:
        "Świetny sklep z doskonałą obsługą klienta. Towar dotarł szybko i w dobrym stanie. Komunikacja była bezproblemowa i szybka. Mogę tylko polecić, na pewno kupię ponownie.",
      previewText2: "poleca",
    },
  },
  branding: {
    title: "Branding",
    sizeAndForm: {
      title: "Rozmiar i kształt powiadomienia",
      classic: "Klasyczna",
      small: "Niska",
      compact: "Kompaktowa",
    },
    defaultSettings: {
      title: "Ustawienia podstawowe",
      backgroundColor: "Kolor tła",
      textColor: "Kolor tekstu",
      backgroundOpacity: "Przezroczystość tła",
      borderRadius: "Zaokrąglenie rogów",
    },
    icons: {
      title: "Wyświetlaj ikony",
      iconColor: "Kolor ikony",
      backgroundColor: "Kolor tła ikony",
      backgroundRadius: "Zaokrąglenie tła ikony",
    },
  },
  analytics: {
    title: "Analityka danych",
    lastOrders: "Ostatnie zamówienia",
    lastRegistrations: "Ostatnie rejestracje",
    updateData: "Aktualizuj dane",
    dateAndTime: "Data i godzina",
    customerName: "Nazwa klienta",
    customerLocation: "Lokalizacja klienta",
  },
  standardSettingsModal: {
    title: "Wygląd zostanie przywrócony do ustawień domyślnych",
    description: "Wszystkie zmiany zostaną nadpisane.",
    applyButton: "Zastosuj ustawienia domyślne",
    closeButton: "Zamknij",
  },
};
